import { Box, Container, Typography, Link, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#263238",
        color: "#fff",
        pt: 3, // Zmniejszono z 6 na 3 (24px)
        pb: 2, // Zmniejszono z 3 na 2 (16px)
        mt: "auto",
        borderTop: "2px solid #4FC3F7",
      }}
    >
      <Container maxWidth="lg">
        {/* Zmniejszono spacing z 4 na 2, aby kolumny były bliżej siebie */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" fontWeight="700" gutterBottom>
              twojaopiekunka.pl
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8, lineHeight: 1.5 }}>
              Największa baza sprawdzonych opiekunek w Twojej okolicy.
            </Typography>
          </Grid>

          <Grid item xs={6} md={2}>
            <Typography variant="subtitle2" fontWeight="700" gutterBottom>
              Serwis
            </Typography>
            <Stack spacing={0.5}>
              {" "}
              {/* Zmniejszono odstępy między linkami */}
              <Link
                href="/szukaj"
                color="inherit"
                underline="hover"
                variant="body2"
              >
                Szukaj
              </Link>
              <Link
                href="/cennik"
                color="inherit"
                underline="hover"
                variant="body2"
              >
                Cennik
              </Link>
              <Link
                href="/faq"
                color="inherit"
                underline="hover"
                variant="body2"
              >
                FAQ
              </Link>
            </Stack>
          </Grid>

          <Grid item xs={6} md={2}>
            <Typography variant="subtitle2" fontWeight="700" gutterBottom>
              Informacje
            </Typography>
            <Stack spacing={0.5}>
              <Link
                href="/regulamin"
                color="inherit"
                underline="hover"
                variant="body2"
              >
                Regulamin
              </Link>
              <Link
                href="/polityka-prywatnosci"
                color="inherit"
                underline="hover"
                variant="body2"
              >
                Polityka
              </Link>
              <Link
                href="/kontakt"
                color="inherit"
                underline="hover"
                variant="body2"
              >
                Kontakt
              </Link>
            </Stack>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="subtitle2" fontWeight="700" gutterBottom>
              Kontakt
            </Typography>
            <Stack spacing={1}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EmailIcon sx={{ fontSize: "1rem", opacity: 0.7 }} />
                <Typography variant="body2">
                  kontakt@twojaopiekunka.pl
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PhoneIcon sx={{ fontSize: "1rem", opacity: 0.7 }} />
                <Typography variant="body2">+48 602 209 858</Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        <Box
          sx={{
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            mt: 3,
            pt: 2,
            textAlign: "center",
          }}
        >
          <Typography variant="caption" sx={{ display: "block", opacity: 0.7 }}>
            &copy; {new Date().getFullYear()} Allworks sp. z o.o.
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.5 }}>
            Realizacja:{" "}
            <Link
              href="https://michaljaskulski.pl"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
              sx={{ fontWeight: "600" }}
            >
              Michał Jaskulski
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
